import { Injectable } from '@angular/core';
import { CatalogsService } from 'src/app/services/catalogs.service';
import { FiltrarProyectosService } from 'src/app/services/filtrar-proyectos.service';
import { Observable } from 'rxjs';  // 📌 Importar Observable
import { map } from 'rxjs/operators';  // 📌 Importar map para transformar datos

@Injectable({
  providedIn: 'root'
})
export class GetAniosService {

  constructor(
    private requestsService: CatalogsService,
    private filtrarProyectosService: FiltrarProyectosService
  ) { }

  obtenerAnios(): Observable<string[]> {  // 📌 Observable de strings
    const { token } = this.filtrarProyectosService.validacionUsuarios();

    return this.requestsService.getYears(token).pipe(
      map((data: any[]) => data.map(item => item.Año)) // 📌 Extrae solo "Año"
    );
  }
}
